import { Injectable } from '@angular/core';
import {
  KalturaClient,
  ConversionProfileListAction,
  KalturaConversionProfileFilter,
  KalturaConversionProfileType,
  KalturaFilterPager,
  KalturaConversionProfile,
} from 'kaltura-ngx-client';
import { Observable } from 'rxjs';

@Injectable()
export class KalturaLiveStreamService {
  constructor(private _kalturaServerClient: KalturaClient) {}

  public getKalturaConversionProfiles(): Observable<KalturaConversionProfile[]> {
    // filter
    const kalturaConversionProfileFilter = new KalturaConversionProfileFilter({
      typeEqual: KalturaConversionProfileType.liveStream,
    });

    // pager
    const kalturaFilterPager = new KalturaFilterPager({ pageSize: 500, pageIndex: 1 });

    return this._kalturaServerClient
      .request(new ConversionProfileListAction({ filter: kalturaConversionProfileFilter, pager: kalturaFilterPager }))
      .map((response) => <KalturaConversionProfile[]>response.objects);
  }
}
